var domObjects = [];
var players = [];
var linkPath = {};

;(function(site, undefined){
	var analyzeVideo = function(item, index) {
		var col = 'grid-col-'+ item.cols;
		var row = 'grid-row-'+ item.rows;

		var videoContainer = document.createElement('div');
			videoContainer.classList = 'grid-item ' + col + ' ' + row;
		var videoInner = document.createElement('div');
			videoInner.classList = 'grid-item-inner';

		var videoElem = document.createElement('video');
			videoElem.id = 'videoItem-'+index;
			videoElem.classList = 'video-js vjs-default-skin vjs-big-play-centered';
			videoElem.setAttribute('controls', true);
			videoElem.setAttribute('loop', true);
			if (item.poster.length > 0) {
				videoElem.setAttribute('poster', item.poster);	
			}
		var videoSrc = document.createElement('source');
			videoSrc.src = item.path;
			videoSrc.type = 'video/mp4';

		videoElem.appendChild(videoSrc);
		videoInner.appendChild(videoElem);
		videoContainer.appendChild(videoInner);
		domObjects.push(videoContainer);
		return [videoContainer, 'videoItem-' + index];
	};
	var analyzeImage = function(item) {
		var col = 'grid-col-'+ item.cols;
		var row = 'grid-row-'+ item.rows;

		var imageContainer = document.createElement('div');
			imageContainer.classList = 'grid-item ' + col + ' ' + row;
		var imageInner = document.createElement('div');
			imageInner.classList = 'grid-item-inner';
		var imageElem = document.createElement('img');
			imageElem.src = item.path;
		var imageLink;
		var seeMore;
		if (item.link.length > 0) {
			imageContainer.classList.add('item-link')
			imageLink = document.createElement('a');
			imageLink.href = item.link;
			imageLink.target = '_blank';

			seeMore = document.createElement('div');
			seeMore.classList.add('link-hover-state');
			seeMore.innerHTML = 'Click to View';

			imageLink.appendChild(imageElem);
			imageLink.appendChild(seeMore);
			imageInner.appendChild(imageLink);
		} else {
			imageInner.appendChild(imageElem);
		}
		imageContainer.appendChild(imageInner);
		return [imageContainer];
	};
	var analyzeContents = function(item) {
		var createParent = function() {
			var parentContainer = document.createElement('div');
				parentContainer.classList.add('grid-item');
				parentContainer.classList.add('grid-col-' + item.cols);
				parentContainer.classList.add('grid-row-' + item.rows);
			return parentContainer;
		};
		var createInnerGrid = function() {
			var innerGrid = document.createElement('div');
				innerGrid.classList.add('inner-grid');
			return innerGrid;
		};
		var generateChildren = function(container) {
			// var childre
			for (var i in item.children) {
				var child = analyzeImage(item.children[i]);
				child[0].classList.add('inner-grid-type-' + item.children[i].type)
				// console.log(container, child);
				container.appendChild(child[0]);
			}
			return container;
		}
		var container = createParent();
		var inner = generateChildren(createInnerGrid());
		// console.log(item, container, inner);
		container.appendChild(inner);
		return [container];
	};
	var defineContent = function(item, index) {
		switch (item.type) {
			case 'video':
				var domVideo = analyzeVideo(item, index);
				$('#gridTarget').append(domVideo[0]);
				var player = videojs(domVideo[1]);
				players.push(player);
				player.on('play', function() {
					var self = this;
					players.forEach(function(player, index, object) {
						if (!player.paused() && player !== self) {
							console.log(player, players[index], object);
							player.pause();
						}
					})
				})
				break;
			case 'image':
				var domImage = analyzeImage(item);
				$('#gridTarget').append(domImage[0]);
				break;
			case 'full':
				var domImage = analyzeImage(item);
				$('#gridTarget').append(domImage[0]);
				break;
			case 'triple':
				var tripleContainer = analyzeContents(item);
				$('#gridTarget').append(tripleContainer[0]);
				// console.log(tripleContainer);
				break;
			default:
				break;
		}
	};
	var init = function(){
		data.forEach(function(item, index) {
			defineContent(item, index);
		});
	};
	$(function(){
		init();
	});
})(window.site=window.site || {});